import React from "react";
import PropTypes from "prop-types";

const ToggleSwitch = ({ id, checked, disabled = false, onChange, ariaLabel }) => {
  const handleClick = () => {
    if (disabled) return;
    onChange(!checked);
  };

  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={handleClick}
      className={`config-toggle${checked ? " is-on" : ""}${disabled ? " is-disabled" : ""}`}
    >
      <span className="config-toggle-knob" />
    </button>
  );
};

ToggleSwitch.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
};

export default ToggleSwitch;
